import { Box, Button, Divider, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import ButtonLink from 'components/atoms/ButtonLink'
import ConfirmationDialog from 'components/atoms/ConfirmationDialog'
import TitleBar from 'components/atoms/TitleBar'

import useConfirmationDialog from 'hooks/useConfirmationDialog'

import {
  getSessionsStepUrl,
  SESSIONS_STEP_PLANNING,
} from '../Sessions/sessionsLib'

const GridWrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 2fr',
  columnGap: theme.spacing(3),
  paddingBottom: theme.spacing(1),
}))

export default function AssignmentPublication({
  session,
  handleValidation,
  handleStartAssignment,
  readOnly,
  contentIsReadOnly = false,
}) {
  const { t } = useTranslation()

  const navigate = useNavigate()

  const {
    openConfirmationDialog,
    handleConfirmConfirmationDialog,
    handleOpenConfirmationDialog,
    handleCloseConfirmationDialog,
  } = useConfirmationDialog(handleStartAssignment)

  return (
    <div data-testid="assignment-publication">
      <TitleBar
        title={t('assignment.publication.contentTitle')}
        description={t('assignment.publication.contentDescription')}
        rightColumn={
          <>
            <ButtonLink
              color="textPrimary"
              underline="none"
              data-testid="button-gotoplanning"
              onClick={() =>
                navigate(
                  getSessionsStepUrl(session.sessionId, SESSIONS_STEP_PLANNING)
                )
              }
              disabled={
                !!session.assignmentStartedAt || readOnly || contentIsReadOnly
              }
            >
              <strong>{t('assignment.publication.extendPublication')}</strong>
            </ButtonLink>
            <Box pr={2} />
            <Button
              color="primary"
              variant="contained"
              data-testid="button-confirm"
              disabled={!handleValidation() || readOnly || contentIsReadOnly}
              onClick={handleOpenConfirmationDialog}
              sx={{ marginLeft: (theme) => theme.spacing(2) }}
            >
              {t('assignment.publication.closePublication')}
            </Button>
          </>
        }
      />
      <GridWrapper>
        <div>
          <Typography variant="body2" color="textSecondary">
            {t('assignment.publication.onSale')}
          </Typography>
          <Typography variant="body2" color="primary">
            <strong>{session.onSale}</strong>
          </Typography>
        </div>
        <div>
          <Typography variant="body2" color="textSecondary">
            {t('assignment.publication.requestedAtGivenPrice')}
          </Typography>
          <Typography variant="body2" color="primary">
            <strong>{session.requestedAtGivenPrice}</strong>
          </Typography>
        </div>
        <div>
          <Typography variant="body2" color="textSecondary">
            {t('assignment.publication.requestedWithReprice')}
          </Typography>
          <Typography variant="body2" color="primary">
            <strong>{session.requestedWithReprice}</strong>
          </Typography>
        </div>
        <div />
      </GridWrapper>
      <Divider />
      <Box pb={3} />

      <ConfirmationDialog
        title={t('assignment.publication.confirmationDialog.title')}
        content={t('assignment.publication.confirmationDialog.content')}
        open={openConfirmationDialog}
        handleClose={handleCloseConfirmationDialog}
        handleSubmit={handleConfirmConfirmationDialog}
      />
    </div>
  )
}

AssignmentPublication.propTypes = {
  session: T.object.isRequired,
  partners: T.array,
  handleValidation: T.func.isRequired,
  handleStartAssignment: T.func,
  handleCapChange: T.func,
  isFetchingPartners: T.bool,
  readOnly: T.bool,
  contentIsReadOnly: T.bool,
}
